import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { KBQSelectedOptions } from 'components/KBQSelect'

const initialState: KBQSelectedOptions[] = []

const defaultSelectedLostShopperKBQOptionsSlices = createSlice({
  name: 'DefaultSelectedKBQOptions',
  initialState,
  reducers: {
    setDefaultKBQOption(state, action: PayloadAction<KBQSelectedOptions>) {
      return state.filter(({ id }) => id !== action.payload.id).concat(action.payload)
    },
    clearDefaultKBQOptions(state) {
      return initialState
    },
  },
})

export const { setDefaultKBQOption, clearDefaultKBQOptions } =
  defaultSelectedLostShopperKBQOptionsSlices.actions

export default defaultSelectedLostShopperKBQOptionsSlices.reducer
